import React from 'react';
import { Heart, Sparkles, ExternalLink, Globe } from 'lucide-react';
import { YoutubeIcon } from './icons/YoutubeIcon';
import { soundEngine } from '../utils/audio';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t-2 border-pink-100 pt-12 pb-8 relative overflow-hidden">
      
      {/* Subtle background decoration */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center space-y-6">
          
          {/* Logo */}
          <div className="max-w-xs sm:max-w-sm">
            <img
              src="/images/logo-wide.jpg"
              alt="Melodalis"
              className="w-full h-auto object-contain cursor-pointer transition-transform hover:scale-105"
              onClick={() => soundEngine.playSparkleSfx()}
            />
          </div>

          <p className="text-gray-500 text-sm max-w-md">
            The colorful, kawaii world of songs, smiles, and guitar melodies for music lovers everywhere.
          </p>

          {/* Social and Domain Links */}
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="https://www.youtube.com/@Melodalis-music"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => soundEngine.playPopSfx()}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-red-50 text-red-600 border border-red-200 font-bold text-xs hover:bg-red-500 hover:text-white transition-all shadow-xs"
            >
              <YoutubeIcon className="w-4 h-4 fill-current" />
              <span>YouTube: @Melodalis-music</span>
              <ExternalLink className="w-3 h-3 ml-0.5" />
            </a>

            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-purple-50 text-purple-700 border border-purple-200 font-bold text-xs">
              <Globe className="w-4 h-4 text-purple-500" />
              <span>melodalis.com</span>
            </div>
          </div>

          {/* Cloudflare Pages note & copyright */}
          <div className="pt-6 border-t border-pink-100 w-full flex flex-col sm:flex-row items-center justify-between text-xs text-gray-400 gap-3">
            <div>
              © {new Date().getFullYear()} <b>Melodalis</b>. All rights reserved. Made with 💖 and music.
            </div>
            <div className="flex items-center gap-1.5">
              <span>Hosted on</span>
              <span className="font-semibold text-orange-500">Cloudflare Pages</span>
              <span>•</span>
              <span className="text-pink-500 font-medium">Keep singing! 🌸</span>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};
